export default "__VITE_ASSET__BQflW7vq__"